import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

export const StyledTooltip = styled.span`
    display: block;
    visibility: hidden;
    opacity: 0;
    background-color: rgba(97, 97, 97, 0.9);
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    font-size: 10px;
    border-radius: 4px;
    padding: 4px 8px;
    position: fixed;
    z-index: 1;
    transition: opacity 0.3s, visibility 0.3s;
`;

export const StyledButton = styled.button`
    position: relative;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 0;
    outline: none;
    cursor: pointer;
    background-color: transparent;
    :hover {
        ${StyledTooltip} {
            visibility: visible;
            opacity: 1;
        };
    };
    ${({ backgroundColor }) => backgroundColor && css`
        background-color: ${backgroundColor};
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
    `};
    ${({ size }) => size === 'small' && css`
        padding: 6px;
        width: 20px;
        height: 20px;
    `};
    ${({ size }) => size === 'medium' && css`
        padding: 8px;
        width: 30px;
        height: 30px;
    `};
    ${({ size }) => size === 'large' && css`
        padding: 10px;
        width: 40px;
        height: 40px;
    `};
    ${({ disabled }) => disabled && css`
        pointer-events: none;
        opacity: 0.5;
    `};
    ${({ customStyle }) => customStyle && customStyle};
`;

export const StyledButtonLink = styled(Link)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 0;
    &.active {
        background-color: ${({ theme }) => theme.colors.white};
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
    }
`;

export const StyledIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`;